var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUsersFilled = function SvgUsersFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.001 1.041a8.958 8.958 0 1 0 0 17.917 8.958 8.958 0 0 0 0-17.917m-.007 4.167a2.71 2.71 0 0 0-2.711 2.708 2.71 2.71 0 0 0 2.711 2.708 2.71 2.71 0 0 0 2.712-2.708 2.71 2.71 0 0 0-2.712-2.708m.007 6.666a6.62 6.62 0 0 0-4.6 1.841.625.625 0 0 0 0 .902 6.62 6.62 0 0 0 4.6 1.84 6.62 6.62 0 0 0 4.6-1.84.625.625 0 0 0 0-.902 6.62 6.62 0 0 0-4.6-1.84",
    clipRule: "evenodd"
  })));
};
export default SvgUsersFilled;